export default {
  getAdminUser (state) {
    return state.adminUser
  }
}



//////////////////
// WEBPACK FOOTER
// ./store/getters.js
// module id = null
// module chunks = 